
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_zolyv_14",
  "code-editor": "awsui_code-editor_1gl9c_zolyv_14",
  "pane": "awsui_pane_1gl9c_zolyv_556",
  "pane__close-container": "awsui_pane__close-container_1gl9c_zolyv_567",
  "pane__list": "awsui_pane__list_1gl9c_zolyv_572",
  "pane__table": "awsui_pane__table_1gl9c_zolyv_579",
  "pane__item": "awsui_pane__item_1gl9c_zolyv_585",
  "pane__cell": "awsui_pane__cell_1gl9c_zolyv_585",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_zolyv_599",
  "pane__location": "awsui_pane__location_1gl9c_zolyv_620",
  "pane__description": "awsui_pane__description_1gl9c_zolyv_620",
  "focus-lock": "awsui_focus-lock_1gl9c_zolyv_635",
  "editor": "awsui_editor_1gl9c_zolyv_679",
  "editor-refresh": "awsui_editor-refresh_1gl9c_zolyv_709",
  "status-bar": "awsui_status-bar_1gl9c_zolyv_714",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_zolyv_723",
  "status-bar__left": "awsui_status-bar__left_1gl9c_zolyv_727",
  "status-bar__right": "awsui_status-bar__right_1gl9c_zolyv_734",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_zolyv_738",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_zolyv_738",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_zolyv_744",
  "tab-list": "awsui_tab-list_1gl9c_zolyv_749",
  "tab-button": "awsui_tab-button_1gl9c_zolyv_754",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_zolyv_787",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_zolyv_790",
  "tab-button--active": "awsui_tab-button--active_1gl9c_zolyv_799",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_zolyv_815",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_zolyv_848",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_zolyv_855",
  "count": "awsui_count_1gl9c_zolyv_864",
  "text": "awsui_text_1gl9c_zolyv_867",
  "loading-screen": "awsui_loading-screen_1gl9c_zolyv_889",
  "error-screen": "awsui_error-screen_1gl9c_zolyv_890"
};
  